
export const startViewTransition = (updateCallback: () => void | Promise<void>): void => {
    if (!document.startViewTransition) {
        updateCallback();
    } else {
        document.startViewTransition(updateCallback);
    }
};